import React, { useEffect, useRef } from "react";
import { MentionsInput, Mention } from "react-mentions";
import autosize from "autosize";
import { Avatar } from "@material-ui/core";
import "./DynamicInput.scss"

function DynamicInput({
  MentionsInputProps,
  MentionsProps,
  setTextMessage,
  textMessage,
}) {
  const textareaRef = useRef(null);
  useEffect(() => {
    if (textareaRef.current) {
      textareaRef.current.focus();
      autosize(textareaRef.current);
    }
    return () => {};
  }, []);

  function renderSuggestions(suggestion) {
    return (
      <div style={{ margin: 5 }}>
        <div
          style={{ flexDirection: "row", alignItems: "center" }}
          onClick={() => {
            setTextMessage((oldText) => oldText);
          }}
        >
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
            }}
          >
            <Avatar
              style={{
                width: 34,
                height: 34,
                borderRadius: 34,
              }}
              src={suggestion.photoURL}
            />
            <div style={{ marginLeft: 15 }}>{`${suggestion.display}`} </div>
          </div>
        </div>
        <div
          style={{
            marginVertical: 5,
            marginLeft: 50,
            borderWidth: 0.5,
          }}
        />
      </div>
    );
  }
  return (
    <MentionsInput
      value={textMessage}
      onChange={({ target }) => setTextMessage(target.value)}
      ref={textareaRef}
      {...MentionsInputProps}
    >
      <Mention {...MentionsProps} renderSuggestion={renderSuggestions} />
    </MentionsInput>
  );
}

export default DynamicInput;
